import { useState } from 'react'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'

import RichTextbox from '../../../../components/dashboard/controls/RichTextBox'
import DashboardButton from '../../../../components/dashboard/DashboardButton'
import Flex from '../../../../components/layouts/Flex'
import EmptyDetails from '../../../../components/EmptyDetails'
import JobComment from './JobComment'

import useFetch from '../../../../hooks/useFetch'

import axiosInstance from '../../../../services/config/AxiosIntance'

const JobComments = ({ jobId }) => {
  const { data, refetch } = useFetch('/job-comments?job_id=' + jobId)

  const [newComment, setNewComment] = useState()
  const [loading, setLoading] = useState(false)

  const { addToast } = useToasts()

  const handleAddComment = async () => {
    setLoading(true)
    try {
      await axiosInstance.post('/job-comment', {
        job_id: jobId,
        comment: newComment,
        user_id: localStorage.getItem('id'),
      })
      addToast('Comment added successfully.', { appearance: 'success' })
    } catch (error) {
      addToast('Failed to add comment.', {
        appearance: 'error',
      })
    } finally {
      setNewComment('')
      setLoading(false)
      refetch()
    }
  }

  return (
    <StyledJobComments>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        direction="column"
      >
        <RichTextbox content={newComment} setContent={setNewComment} />
        <DashboardButton
          notIcon
          type="submit"
          text={loading ? 'Loading...' : 'Add Comment'}
          disabled={!newComment || loading}
          onClick={handleAddComment}
        >
          Add Comment
        </DashboardButton>
      </Flex>

      {data?.resp?.length > 0 ? (
        data.resp.map((comment, index) => (
          <JobComment
            key={index}
            name="Roswaldo Flores"
            comment={comment.comment}
            createdAt={comment.created_at}
          />
        ))
      ) : (
        <EmptyDetails message="No comments yet." />
      )}
    </StyledJobComments>
  )
}

const StyledJobComments = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`

export default JobComments
